import { QuestionnaireFormData } from '@/features/questionnaires/types/questionnaire.interface';
import { MenuItem } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SelectInput } from '@/shared';

export const TextQuestionParameters = ({
  questionIndex,
}: {
  questionIndex: number;
}) => {
  const { t } = useTranslation();
  const form = useFormContext<QuestionnaireFormData>();

  return (
    <SelectInput
      form={form}
      name={`questions.${questionIndex}.parameters.size`}
      label={t('pages.studies.questions.size.label')}
    >
      <MenuItem value="S">{t('pages.studies.questions.size.small')}</MenuItem>
      <MenuItem value="M">{t('pages.studies.questions.size.medium')}</MenuItem>
      <MenuItem value="L">{t('pages.studies.questions.size.large')}</MenuItem>
    </SelectInput>
  );
};
